export default __webpack_public_path__ + "media/src/assets/images/truck_pickup-71322466a7d8136ae2343779daab5aa7.svg";